export type ProcessFileResult = {
  name: string;
  base64: string;
};

export default async function processFileBlob(
  file: File,
): Promise<ProcessFileResult> {
  // eslint-disable-next-line promise/avoid-new
  return new Promise<ProcessFileResult>((resolve) => {
    const fileReader = new FileReader();
    fileReader.onload = (event): void => {
      resolve({
        name: file.name,
        base64: event.target?.result as string,
      });
    };
    fileReader.readAsDataURL(file);
  });
}
